import {configureStore} from '@reduxjs/toolkit'

import userSlice from './Slice/userSlice'
import roleSlice from './Slice/roleSlice'
import passwordSlice from './Slice/passwordSlice'
import toolSlice from './Slice/toolSlice'
import campusSlice from './Slice/campusSlice'
import generalSlice from './Slice/generalSlice'
import academicSlice from './Slice/academicSlice'
import lecturerSlice from './Slice/lecturerSlice'
import regulationSlice from './Slice/regulationSlice'
import financeSlice from './Slice/financeSlice'
import studentSlice from './Slice/studentSlice'
import adminSlice from './Slice/adminSlice'
import formSlice from './Slice/formSlice'
import chatSlice from './Slice/chatSlice'
import reportSlice from './Slice/reportSlice'
import expenseSlice from './Slice/expenseSlice'

export const store = configureStore({
  reducer: {
    user: userSlice,
    role: roleSlice,
    passwordSlice: passwordSlice,
    tools: toolSlice,
    campus: campusSlice,
    general: generalSlice,
    academic: academicSlice,
    lecturer: lecturerSlice,
    regulation: regulationSlice,
    finance: financeSlice,
    student: studentSlice,
    admin: adminSlice,
    form: formSlice,
    chat: chatSlice,
    report: reportSlice,
    expense: expenseSlice,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
